import { z } from 'zod/v3'

export const APP_LINKING_MODES = ['prod', 'dev', 'off'] as const
export type AppLinkingMode = (typeof APP_LINKING_MODES)[number]
export const AppLinkingModeSchema = z.enum(APP_LINKING_MODES).catch('off')
